// Internal modules
import { getCrsFields } from '@/store';
import {
  DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY,
  SET_TAX_DETAILS,
  SET_TAX_STATUS,
} from '@/components/CRSFields/constants';
import { logCrsTaxStatusSelection } from '@/components/CRSFields/fpti';

export const crsResidencyStatusChangeHandler = (
  event,
  dispatch,
  crsTaxStatus,
) => {
  const targetValue = event?.target?.value;
  logCrsTaxStatusSelection(targetValue);
  dispatch({
    type: SET_TAX_STATUS,
    value: {
      ...crsTaxStatus,
      displayError: false,
      error: '',
      value: targetValue,
    },
  });
  if (targetValue === DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY) {
    dispatch({
      type: SET_TAX_DETAILS,
      value: [getCrsFields()],
    });
  }
};
